import _t from 'i18n!nls/search';

export function getCoachSearchQueries(): Record<string, { ctas: string[] }> {
  return {
    python: {
      ctas: [_t('Find Python courses for beginners'), _t('Explore Python learning paths')],
    },
    ai: {
      ctas: [_t('Discover AI basics for beginners'), _t('Explore AI course recommendations')],
    },
    'data analytics': {
      ctas: [_t('Find introductory data analytics courses'), _t('Explore data analytics career paths')],
    },
    'machine learning': {
      ctas: [_t('Discover machine learning fundamentals'), _t('Explore machine learning career paths')],
    },
    google: {
      ctas: [_t('Explore Google courses for beginners'), _t('How will Google skills help my career?')],
    },
    excel: {
      ctas: [_t('Find Excel courses for beginners'), _t('What are examples of advanced Excel skills?')],
    },
    'digital marketing': {
      ctas: [_t('Discover digital marketing basics'), _t('Explore digital marketing career paths')],
    },
    cybersecurity: {
      ctas: [_t('Find cybersecurity courses for beginners'), _t('Discover cybersecurity career paths')],
    },
    'project management': {
      ctas: [_t('Explore project management fundamentals'), _t('Find project management certifications')],
    },
    'graphic design': {
      ctas: [_t('Discover graphic design basics'), _t('Explore graphic design tools')],
    },
    marketing: {
      ctas: [_t('Find marketing courses for beginners'), _t('Explore marketing specializations')],
    },
    'artificial intelligence': {
      ctas: [_t('Discover AI fundamentals'), _t('Explore AI research areas')],
    },
    'power bi': {
      ctas: [_t('Find Power BI courses for beginners'), _t('Explore advanced Power BI techniques')],
    },
    'data science': {
      ctas: [_t('Discover data science fundamentals'), _t('Explore data science career paths')],
    },
    sql: {
      ctas: [_t('Find SQL courses for beginners'), _t('Explore advanced SQL topics')],
    },
    'generative ai': {
      ctas: [_t('Discover generative AI basics'), _t('Explore generative AI applications')],
    },
    'microsoft excel': {
      ctas: [_t('Find Excel courses for beginners'), _t('Explore advanced Excel functions')],
    },
    'free courses': {
      ctas: [_t('Discover popular free courses'), _t('Explore free course categories')],
    },
    java: {
      ctas: [_t('Find Java courses for beginners'), _t('Explore Java development paths')],
    },
    psychology: {
      ctas: [_t('Discover psychology basics'), _t('Explore psychology specializations')],
    },
    finance: {
      ctas: [_t('Find finance courses for beginners'), _t('Explore finance career paths')],
    },
    accounting: {
      ctas: [_t('Discover accounting fundamentals'), _t('Explore accounting certifications')],
    },
    english: {
      ctas: [_t('Find English courses for beginners'), _t('Explore English proficiency tests')],
    },
    'prompt engineering': {
      ctas: [_t('Find prompt engineering basics'), _t('Explore AI prompt techniques')],
    },
    aws: {
      ctas: [_t('Discover AWS fundamentals'), _t('Explore AWS certification paths')],
    },
    'product management': {
      ctas: [_t('Find product management basics'), _t('Explore product management skills')],
    },
    'data analyst': {
      ctas: [_t('Find data analyst courses'), _t('Explore data analyst skills')],
    },
    'web development': {
      ctas: [_t('Discover web development basics'), _t('Explore web development frameworks')],
    },
    'free project management': {
      ctas: [_t('Find project management basics courses'), _t('Explore project management tools')],
    },
    design: {
      ctas: [_t('Discover design fundamentals'), _t('Explore UX Design courses')],
    },
    'english speaking': {
      ctas: [_t('Explore English beginner courses'), _t('Find English conversation courses')],
    },
    'c++': {
      ctas: [_t('Discover C++ programming basics'), _t('Explore advanced C++ topics')],
    },
    'business analytics': {
      ctas: [_t('Find business analytics fundamentals'), _t('Explore business analytics tools')],
    },
    trading: {
      ctas: [_t('Find trading courses for beginners'), _t('Explore advanced trading strategies')],
    },
    'andrew ng': {
      ctas: [_t('Discover Deeplearning.ai beginner courses'), _t('Explore AI career paths')],
    },
    statistics: {
      ctas: [_t('Discover statistics fundamentals'), _t('Explore advanced statistical methods')],
    },
    devops: {
      ctas: [_t('Find DevOps courses for beginners'), _t('Explore DevOps tools and practices')],
    },
    ibm: {
      ctas: [_t('Discover IBM technology basics'), _t('Explore IBM AI courses')],
    },
    microsoft: {
      ctas: [_t('Find Microsoft AI courses'), _t('Explore Microsoft Copilot courses')],
    },
    'data analysis': {
      ctas: [_t('Discover data analysis fundamentals courses'), _t('Explore data analysis techniques')],
    },
    'human resources': {
      ctas: [_t('Find HR courses for beginners'), _t('Explore HR career paths')],
    },
    'ui / ux design': {
      ctas: [_t('Discover UI/UX design basics'), _t('Explore UI/UX design tools')],
    },
    'video editing': {
      ctas: [_t('Find video editing courses'), _t('Explore video editing software')],
    },
    tableau: {
      ctas: [_t('Tableau basics for beginners'), _t('Why learn Tableau now?')],
    },
    'data engineering': {
      ctas: [_t('Data engineering beginner courses'), _t('Is data engineering for me?')],
    },
    'communication skills': {
      ctas: [_t('How can I improve my communication skills?'), _t('Why do communication skills matter?')],
    },
    hr: {
      ctas: [_t('HR basics for beginners'), _t('Is HR a good career?')],
    },
    'deep learning': {
      ctas: [_t('Deep learning basics for beginners'), _t('How hard is it to learn deep learning?')],
    },
    'project management certification': {
      ctas: [_t('Project management for beginners'), _t('Explore project management career paths')],
    },
    'python for beginners': {
      ctas: [_t('Python guided projects for beginners'), _t('Is Python right for me')],
    },
    spanish: {
      ctas: [_t('Spanish basics for beginners'), _t('Why learn Spanish now')],
    },
    'cyber security': {
      ctas: [_t('Cyber security fundamentals explained'), _t('Is cyber security for me?')],
    },
    'ux design': {
      ctas: [_t('UX design basics explained'), _t('Why pursue UX design')],
    },
    'social media marketing': {
      ctas: [_t('Social media marketing essentials'), _t('Explore social media marketing career paths')],
    },
    sales: {
      ctas: [_t('Sales techniques for beginner courses'), _t('Explore sales career paths')],
    },
    photoshop: {
      ctas: [_t('Find Photoshop courses for beginners'), _t('Why learn Photoshop?')],
    },
    javascript: {
      ctas: [_t('JavaScript basics for beginners'), _t('How does JavaScript compare to other languages?')],
    },
    law: {
      ctas: [_t('Find Law basics courses for beginners'), _t('What are some legal career paths?')],
    },
    'business analyst': {
      ctas: [_t('Business analysis for beginners'), _t('Is business analysis for me?')],
    },
    business: {
      ctas: [_t('Business fundamentals for beginners'), _t('Explore business careers')],
    },
    'free ai courses': {
      ctas: [_t('Beginner AI courses'), _t('Which AI course to start with?')],
    },
    linux: {
      ctas: [_t('Linux basics for beginners'), _t('Why learn Linux now')],
    },
    seo: {
      ctas: [_t('SEO basics for beginners'), _t('Why learn SEO now?')],
    },
    'french language': {
      ctas: [_t('French basics for beginners'), _t('Why learn French now?')],
    },
    leadership: {
      ctas: [_t('Leadership essentials courses'), _t('Why improve leadership skills?')],
    },
    'marketing digital': {
      ctas: [_t('Digital marketing basics explained'), _t('Is digital marketing for me?')],
    },
    'computer science': {
      ctas: [_t('Computer science basics explained'), _t('Why study computer science')],
    },
    'software engineering': {
      ctas: [_t('Software engineering fundamentals explained'), _t('Is software engineering for me?')],
    },
    'data structures and algorithms': {
      ctas: [_t('DSA basics for beginners'), _t('Why learn DSA now?')],
    },
    'ethical hacking': {
      ctas: [_t('Explain ethical hacking basics explained'), _t('Is ethical hacking for me?')],
    },
    'stock market': {
      ctas: [_t('Stock market basics for beginners'), _t('Why learn about stocks?')],
    },
    'microsoft power bi': {
      ctas: [_t('Power BI basics for beginners'), _t('Why learn Power BI?')],
    },
    writing: {
      ctas: [_t('Writing techniques for beginners'), _t('Why enhance writing skills?')],
    },
    management: {
      ctas: [_t('Management basics for beginners'), _t('Why study management now?')],
    },
    coding: {
      ctas: [_t('Coding basics for beginners'), _t('Which programming language to learn?')],
    },
    copywriting: {
      ctas: [_t('Copywriting essentials explained'), _t('Is copywriting for me?')],
    },
    photography: {
      ctas: [_t('Photography basics for beginners'), _t('Why learn photography now?')],
    },
    'full stack web development': {
      ctas: [_t('Full stack basics courses'), _t('Is full stack dev for me?')],
    },
    'digital marketing free': {
      ctas: [_t('Beginner digital marketing courses'), _t('What are digital marketing career paths?')],
    },
    ingles: {
      ctas: [_t('English basics for beginners'), _t('Why learn English now')],
    },
    architecture: {
      ctas: [_t('Architecture basics for beginners'), _t('Is architecture right for me?')],
    },
    economics: {
      ctas: [_t('Economics fundamentals explained'), _t('Why study economics now?')],
    },
    'supply chain': {
      ctas: [_t('Supply chain basics explained'), _t('Is supply chain for me?')],
    },
    'cloud computing': {
      ctas: [_t('Cloud computing basics explained'), _t('Why learn cloud computing?')],
    },
  };
}
